import { Injectable } from '@angular/core';
import {AppSettings} from '../../../settings/app-settings';
import {Observable} from 'rxjs/Observable';
import {HttpClient} from '@angular/common/http';
import {TStockTransfer} from '../model/t-stock-transfer';

@Injectable()
export class TStockTransferOutService {

  constructor(private  http:HttpClient) { }

  public findByTransactionNumber(tNumber: number): Observable<TStockTransfer> {
    return this.http.get<TStockTransfer>(AppSettings.API_ENDPOINT + "/api/v1/gflock-main-service/trasactions/t-stock-transfer/find-by-t-number/" + tNumber);
  }

  public save(tStockTransfer: TStockTransfer): Observable<TStockTransfer> {
    return this.http.post<TStockTransfer>(AppSettings.API_ENDPOINT + "/api/v1/gflock-main-service/trasactions/t-stock-transfer/save", tStockTransfer);
  }
}



// WEBPACK FOOTER //
// ./src/app/view/transactions/t-stock-transfer-out/service/t-stock-transfer-out.service.ts